import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col, Spinner } from "reactstrap";
import SimpleBar from "simplebar-react";

// i18n
import { withTranslation } from "react-i18next";

const API_BASE = "https://harmanappapi.stechomeyazilim.info";

const NotificationDropdown = props => {
  const [menu, setMenu] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [marking, setMarking] = useState(false);

  const getAuth = () => {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
    return {
      userId: authUser?.ID,
      token: localStorage.getItem("token") || authUser?.Token,
    };
  };

  const isUnread = (n) => n.OKUNDU !== true && n.OKUNDU !== 1;
  const unreadCount = notifications.filter(isUnread).length;

  // OData API'den son bildirimleri çek
  const fetchNotifications = async () => {
    setIsLoading(true);
    try {
      const { userId, token } = getAuth();
      if (!userId || !token) { setIsLoading(false); return; }

      const response = await fetch(
        `${API_BASE}/BILDIRIM_LOGLARI?$filter=KULLANICI_ID eq ${userId}&$orderby=ID desc&$top=10`,
        { method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` } }
      );
      if (!response.ok) {
        console.error("Bildirim API Hatası:", await response.text());
        setIsLoading(false);
        return;
      }
      const result = await response.json();
      if (result && result.value) setNotifications(result.value);
    } catch (error) {
      console.error("Bildirimler çekilemedi:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Tek bildirimi okundu yap (PATCH OKUNDU=true)
  const markAsRead = async (id) => {
    const { token } = getAuth();
    if (!token || !id) return;
    // Optimistik güncelle
    setNotifications(prev => prev.map(n => n.ID === id ? { ...n, OKUNDU: true } : n));
    try {
      await fetch(`${API_BASE}/BILDIRIM_LOGLARI(${id})`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ OKUNDU: true }),
      });
    } catch (e) {
      // Hata olursa geri al
      setNotifications(prev => prev.map(n => n.ID === id ? { ...n, OKUNDU: false } : n));
    }
  };

  // Tümünü okundu yap
  const markAllAsRead = async () => {
    const { token } = getAuth();
    if (!token) return;
    const unread = notifications.filter(isUnread);
    if (unread.length === 0) return;
    setMarking(true);
    setNotifications(prev => prev.map(n => ({ ...n, OKUNDU: true })));
    try {
      await Promise.all(unread.map(n =>
        fetch(`${API_BASE}/BILDIRIM_LOGLARI(${n.ID})`, {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
          body: JSON.stringify({ OKUNDU: true }),
        })
      ));
    } catch (e) {
      fetchNotifications(); // hata olursa sunucudan tazele
    } finally {
      setMarking(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
    // Periyodik tazele (yeni bildirimler için)
    const id = setInterval(fetchNotifications, 60000);
    return () => clearInterval(id);
  }, []);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-bell bx-tada" />
          {unreadCount > 0 && (
            <span className="badge bg-danger rounded-pill">
              {unreadCount}
            </span>
          )}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0 font-size-16"> {props.t("Bildirimler")} </h6>
              </Col>
              <div className="col-auto d-flex align-items-center gap-2">
                {unreadCount > 0 && (
                  <Link
                    to="#!"
                    className="small text-success"
                    onClick={(e) => { e.preventDefault(); if (!marking) markAllAsRead(); }}
                  >
                    <i className="mdi mdi-check-all me-1"></i> Tümünü okundu yap
                  </Link>
                )}
                <Link to="#!" className="small" onClick={(e) => { e.preventDefault(); fetchNotifications(); }}>
                  <i className="mdi mdi-refresh me-1"></i> Yenile
                </Link>
              </div>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            {isLoading ? (
              <div className="text-center py-4">
                <Spinner size="sm" color="primary" />
              </div>
            ) : notifications.length > 0 ? (
              notifications.map((item, index) => {
                const unread = isUnread(item);
                return (
                  <Link
                    to="#!"
                    className="text-reset notification-item"
                    key={item.ID || index}
                    style={unread ? { backgroundColor: "#f1f6ff", display: "block" } : { display: "block" }}
                    onClick={(e) => { e.preventDefault(); if (unread) markAsRead(item.ID); }}
                  >
                    <div className="d-flex">
                      <div className="avatar-xs me-3">
                        <span className={`avatar-title rounded-circle font-size-16 ${unread ? "bg-primary" : "bg-secondary"}`}>
                          <i className="bx bx-info-circle" />
                        </span>
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mt-0 mb-1">
                          {item.BASLIK}
                          {unread && <span className="badge bg-danger ms-2 align-middle">Yeni</span>}
                        </h6>
                        <div className="font-size-12 text-muted">
                          <p className="mb-1">{item.ICERIK}</p>
                          <p className="mb-0">
                            <i className="mdi mdi-clock-outline" />{" "}
                            {item.GONDERIM_TARIHI
                              ? new Date(item.GONDERIM_TARIHI).toLocaleString("tr-TR")
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              })
            ) : (
              <div className="text-center py-5 text-muted">
                <p className="mb-0">Henüz bir bildiriminiz yok.</p>
              </div>
            )}
          </SimpleBar>

          <div className="p-2 border-top d-grid">
            <Link className="btn btn-sm btn-link font-size-14 text-center" to="/bildirim-loglari">
              <i className="mdi mdi-arrow-right-circle me-1"></i> {props.t("Tümünü Gör")}..
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

NotificationDropdown.propTypes = {
  t: PropTypes.any
};

export default withTranslation()(NotificationDropdown);
